import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class SyncWithOdnCommand extends IRequestCommand<
  ISyncWithOdnResponse,
  ErrorDetails,
  ISyncWithOdnParameters> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = "";

  public override setParameters(parameters: ISyncWithOdnParameters) {
    this.urlSections.push('odn');
    this.urlSections.push(`${parameters.carrierId}`);
    this.urlSections.push('syncWithODN');
    this.urlSections.push(`${parameters.travelId}`);
    this._commandBody = parameters;
    this.composeUrl();
  }
}

export interface ISyncWithOdnParameters {
  carrierId: number;
  travelId: string;
}

export interface ISyncWithOdnResponse extends ICommandResponse {
}
